export interface PaginationAriaLabels {
  title: string;
  previous: string;
  current: string;
  next: string;
}

export interface Pagination {
  previous: string;
  next: string;
  indexes: number[];
  pageSize: number;
  first: number;
  last: number;
  ariaLabels: PaginationAriaLabels;
  activePage: number;
}

// use for aem/static content
export interface PaginationContent {
  pagesLimit: number;
  previous: string;
  next: string;
  ariaLabels: PaginationAriaLabels;
}
